import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/homeHeroMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/modarnaBackgroundVector.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/carpainter.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/carpainterImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Food.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/HeroSection.webp");
;
import(/* webpackMode: "eager" */ "/app/src/assets/linkedinProfilePic.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Testimonial-1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Testimonial-2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Testimonial-3.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/client/PreviewScroll.client.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/client/RedirectButton.client.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/client/TrustpilotWidget.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/section/client/TestimonialsSwiper.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Home/client/ContactUsButton.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Home/client/HomePageLoanCalculator.client.jsx");
